import React from "react";

const Inspections = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.125 3.25H17.875V1.625H16.25V3.25H9.75V1.625H8.125V3.25H4.875C3.98125 3.25 3.25 3.98125 3.25 4.875V21.125C3.25 22.0187 3.98125 22.75 4.875 22.75H21.125C22.0187 22.75 22.75 22.0187 22.75 21.125V4.875C22.75 3.98125 22.0187 3.25 21.125 3.25ZM21.125 21.125H4.875V9.75H21.125V21.125ZM21.125 8.125H4.875V4.875H8.125V6.5H9.75V4.875H16.25V6.5H17.875V4.875H21.125V8.125Z" fill="#96CEF6" />
  </svg>
);

export default Inspections;
